import axiosIns from '../../../xaxios';
import { obtenerUrlAPIPagos } from '../utils/funciones';

export default {
  async create(data) {
    return await axiosIns.post(obtenerUrlAPIPagos('programa-universidad/v2'), data);
  },
  async update(id, data) {
    return await axiosIns.patch(obtenerUrlAPIPagos(`programa-universidad/v2/${id}`), data);
  },
};
